<template>
  <!-- Change viewBox and fill params -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 32 32"
  >
    <g>
      <path fill="#810262" d="M0 0h32v32h-32v-32z"></path>
      <path
        fill="none"
        stroke="#fff"
        stroke-linejoin="miter"
        stroke-linecap="butt"
        stroke-miterlimit="10"
        stroke-width="2.1333"
        d="M13.381 23.467h-4.848v-4.778"
      ></path>
      <path
        fill="none"
        stroke="#fff"
        stroke-linejoin="miter"
        stroke-linecap="butt"
        stroke-miterlimit="10"
        stroke-width="2.1333"
        d="M18.619 8.533h4.848v4.778"
      ></path>
      <path
        fill="none"
        stroke="#fff"
        stroke-linejoin="miter"
        stroke-linecap="butt"
        stroke-miterlimit="10"
        stroke-width="2.1333"
        d="M8.533 13.078v-4.545h4.545"
      ></path>
      <path
        fill="none"
        stroke="#fff"
        stroke-linejoin="miter"
        stroke-linecap="butt"
        stroke-miterlimit="10"
        stroke-width="2.1333"
        d="M23.467 18.689v4.778h-4.848"
      ></path>
      <path
        fill="none"
        stroke="#fff"
        stroke-linejoin="miter"
        stroke-linecap="butt"
        stroke-miterlimit="10"
        stroke-width="2.1333"
        d="M23.076 8.533l-14.543 14.645"
      ></path>
      <path
        fill="none"
        stroke="#fff"
        stroke-linejoin="miter"
        stroke-linecap="butt"
        stroke-miterlimit="10"
        stroke-width="2.1333"
        d="M8.533 8.533l14.543 14.645"
      ></path>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>
